/**
 * Fibonacci Pivot Points
 *
 * Pivot levels using Fibonacci ratios (0.382, 0.618, 1.0) applied
 * to the previous period's range.
 *
 * Category: Support/Resistance | Pane: Overlay
 */
import { IndicatorDefinition, PlotData } from "../types/indicator.types";
import { CandleData } from "../../types/chart.types";

export const fibPivotIndicator: IndicatorDefinition = {
  id: "fibpivot",
  name: "Fibonacci Pivot Points",
  shortName: "FIB-PVT",
  category: "support_resistance",
  pane: "overlay",
  params: [],
  plots: [
    { key: "pp", label: "PP", color: "#FF9800", style: "line", lineWidth: 2 },
    { key: "r1", label: "R1", color: "#F44336", style: "line", lineWidth: 1 },
    { key: "r2", label: "R2", color: "#F44336", style: "line", lineWidth: 1 },
    { key: "r3", label: "R3", color: "#D32F2F", style: "line", lineWidth: 1 },
    { key: "s1", label: "S1", color: "#4CAF50", style: "line", lineWidth: 1 },
    { key: "s2", label: "S2", color: "#4CAF50", style: "line", lineWidth: 1 },
    { key: "s3", label: "S3", color: "#388E3C", style: "line", lineWidth: 1 },
  ],
  calculate: (candles: CandleData[], params: Record<string, any>): PlotData[] => {
    if (candles.length < 2) {
      return ["pp","r1","r2","r3","s1","s2","s3"].map(k => ({ key: k, data: [] }));
    }

    const prev = candles[candles.length - 2];
    const pp = (prev.high + prev.low + prev.close) / 3;
    const range = prev.high - prev.low;

    const r1 = pp + 0.382 * range;
    const r2 = pp + 0.618 * range;
    const r3 = pp + 1.000 * range;
    const s1 = pp - 0.382 * range;
    const s2 = pp - 0.618 * range;
    const s3 = pp - 1.000 * range;

    const makeLine = (val: number) =>
      candles.map(c => ({ time: c.time, value: val }));

    return [
      { key: "pp", data: makeLine(pp) },
      { key: "r1", data: makeLine(r1) },
      { key: "r2", data: makeLine(r2) },
      { key: "r3", data: makeLine(r3) },
      { key: "s1", data: makeLine(s1) },
      { key: "s2", data: makeLine(s2) },
      { key: "s3", data: makeLine(s3) },
    ];
  },
};
